import { styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)(() => ({
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "16px",
}));
